import React from "react";
import { Box } from "@mui/material";

const ErrorPage = () => {
  return <Box>Error page</Box>;
};

export default ErrorPage;
